module.exports = __webpack_public_path__ + "img/plane-disabled.e807fce1.svg";